module.exports = __webpack_public_path__ + "img/thumb-009-04.79ad0243.png";